import { createBrowserHistory, type History } from "history";

const historyInstance: History = createBrowserHistory();

export default historyInstance;
